export default __webpack_public_path__ + "static/media/040-speed-limit.697db356.png";